import React, { FC, useState, useEffect } from 'react';
import openLink from 'libs/open-link';
import { getHumanDate } from 'services/v2/order/misc';
import { ellipsisStr } from 'utils/tool';
import './index.scss';

interface ILogisticsInfoProps {
    orderId: string;
    afterSaleId?: string;
    status: string;
    time: string;
    detail: string;
    icon: string;
    signatory: string;
    showExpressIcon?: boolean;
    isSendByShop?: boolean;
    onClickCallback?: () => void;
}

const LogisticsInfo: FC<ILogisticsInfoProps> = ({
    orderId = '',
    status = '',
    time = '',
    detail = '',
    icon = '',
    signatory = '',
    showExpressIcon = false,
    afterSaleId = '',
    isSendByShop = false,
    onClickCallback
}) => {
    const timeText = getHumanDate(time);
    const gotoLogisticsDetail = () => {
        typeof onClickCallback === 'function' && onClickCallback();
        let query = `id=${orderId}`;
        query += afterSaleId ? `&after_sale_id=${afterSaleId}` : '';
        // 显示商家物流
        query += isSendByShop ? `&shop_logistics=1` : '';
        openLink(`/views/neworder/express?${query}`, { title: '查看物流', control: true });
    };

    return (
        <div className="logistics-container" onClick={gotoLogisticsDetail}>
            {afterSaleId && (
                <div className="logistics-desc">{isSendByShop ? '商家' : '我'}寄出的包裹</div>
            )}
            <div className="logistics-content">
                {showExpressIcon && <img className="logistics-icon" src={icon}></img>}
                <div className="logistics-info">
                    <div className="logistics-info-head">
                        {!showExpressIcon && <i className="logistics-info-icon"></i>}
                        <span className="logistics-info-label">物流状态</span>
                        <span className="logistics-info-status">{status}</span>
                        {signatory ? (
                            <span className="logistics-info-signer">
                                签收人：{ellipsisStr(signatory, 4)}
                            </span>
                        ) : null}
                    </div>
                    <div
                        className={`logistics-info-bottom ${
                            showExpressIcon ? '' : 'logistics-info-bottom__margin'
                        }`}
                    >
                        <span className="logistics-info-time">{timeText}</span>
                        <span className="logistics-info-detail">{detail}</span>
                    </div>
                </div>
                <i className="logistics-arrow"></i>
            </div>
        </div>
    );
};

export default LogisticsInfo;
